import { Card, Skeleton, theme } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { CustomDatePicker } from '../../components/CustomDatePicker';
import { SecureGet } from '../../services/axiosCall';
import apis from '../../services/Apis';
import { table } from './struct';

const SCORE_ITEMS = [
  { key: 'teaching_apa_point', label: 'Teaching', icon: '📚', accent: '#f59e0b', max: 400 },
  { key: 'service_apa_point',  label: 'Service',  icon: '🤝', accent: '#10b981', max: 400 },
  { key: 'research_apa_point', label: 'Research', icon: '🔬', accent: '#3b82f6', max: 400 },
];

const ScoreCard = ({ item, value, tok }) => {
  const pct = Math.min(100, Math.round((value / item.max) * 100));
  return (
    <div style={table.scoreCard(item.accent, tok)}>
      <div style={table.scoreAccentCorner(item.accent)} />
      <div style={table.scoreTop(item.accent)}>{item.icon}</div>
      <div style={table.scoreLabel(tok)}>{item.label} APA</div>
      <div style={table.scoreValue(item.accent)}>{value.toFixed(1)}</div>
      <div style={table.barBg(tok)}>
        <div style={table.barFill(pct, item.accent)} />
      </div>
      <div style={table.scoreUnit(tok)}>{pct}% of max {item.max}</div>
    </div>
  );
};

const ResultSkeleton = () => (
  <div>
    <Skeleton.Input active style={{ width: 220, height: 44, borderRadius: 14, marginBottom: 24 }} />
    <div style={table.grid}>
      {[1, 2, 3].map(i => (
        <Skeleton.Input key={i} active style={{ width: '100%', height: 130, borderRadius: 14 }} block />
      ))}
    </div>
    <Skeleton.Input active style={{ width: '100%', height: 90, borderRadius: 16 }} block />
  </div>
);

const Results = () => {
  const { token: tok } = theme.useToken();

  const currentYear = new Date().getFullYear()-1;
  const [selectedYear, setSelectedYear] = useState(Number(currentYear));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleSelectedYear = (_, yearString) =>
    setSelectedYear(Number(yearString));

  const fetchResult = useCallback(() => {
    setLoading(true);
    SecureGet({
      url: apis.APA_RESULT,
      params: { year: selectedYear },
    })
      .then((res) => setData(res.data?.results?.[0] ?? null))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [selectedYear]);

  useEffect(() => { fetchResult(); }, [selectedYear]);

 
  return (
    <Card {...table.wrapper}>
      <div style={table.page}>

        {/* ── Header ── */}
        <div style={table.headerRow}>
          <div>
            <h2 style={table.title(tok)}>APA Score Report</h2>
            <p style={table.subtitle(tok)}>Annual Performance Assessment · {selectedYear}</p>
          </div>
          <CustomDatePicker
            selectedYear={selectedYear}
            handleSelectedYear={handleSelectedYear}
          />
        </div>

        {/* ── Body ── */}
        {loading ? (
          <ResultSkeleton tok={tok} />
        ) : !data ? (
          <div style={table.empty(tok)}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📭</div>
            No APA data found for {selectedYear}.
          </div>
        ) : (
          <>
            {/* Score Cards */}
            <div style={table.grid}>
              {SCORE_ITEMS.map(item => (
                <ScoreCard key={item.key} item={item} value={data[item.key] ?? 0} tok={tok} />
              ))}
            </div>

            {/* Final APA */}
            <div style={table.finalCard}>
              <div>
                <div style={table.finalLabel}>{selectedYear} Final APA Score</div>
                <div style={table.finalValue}>{data.final_apa_point?.toFixed(2)}</div>
              </div>
              <div style={table.finalBadge}>✦ {selectedYear} Result</div>
            </div>
          </>
        )}

      </div>
    </Card>
  );
};

export default Results;